import { defineNuxtPlugin, onNuxtReady, useNuxtApp, useRouter } from '#imports'

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return

  const nuxtApp = useNuxtApp()
  const router = useRouter()

  const refresh = () => {
    requestAnimationFrame(() => {
      nuxtApp.$refreshHardAos?.()
    })
  }

  onNuxtReady(() => {
    refresh()
    router.afterEach(() => {
      refresh()
    })
  })
})
